

import { defineComponent, PropType } from 'vue';
import { mapState, mapStores } from 'pinia';

import ModalBase from '~/components/modals/modal-base';
import Modal from '~/components/modals/modal.vue';
import DashboardAddGrid from '~/components/add-widget-grid.vue';
import { useWidgetStore } from '~/store/widgets.store';

import { Widget } from '~/models/widget.model';

export default defineComponent({

    extends: ModalBase,

    components: {
        Modal,

        DashboardAddGrid,
    },

    props: {
        widgets: { type: Array as PropType<Widget[]>, default: () => []},
    },

    data() {
        return {
            valid:false,
            pristine: true,
            selection: null,
        }
    },

    computed: {
        ...mapStores(useWidgetStore),
        ...mapState(useWidgetStore, ['templates']),
    },

    methods: {
        async submit(): Promise<void> {

            if(!this.valid || this.pristine || !this.selection) {
                return;
            }

            try {
                this.$emit('submitted', this.selection);
                this.close();
            } catch(error) {
                this.$notifyError(this.$t('dashboard-add.failure', error));
            }
        },

        onSelectionChange(widgets: Widget[]) {
            this.pristine = false;
            this.valid = !!widgets && !!widgets.length;
            this.selection = widgets;
        }
    },
});
